import React from 'react';
import Select from 'react-select';
import PropTypes from 'prop-types';

const OperatorSelector = props => {
    const options = props.operators.map(elem => (
        {value: elem.id, label: elem.name}
    ));
    options.push({value: null, label: ""});
    const defaultValue = options.find(elem =>
        elem.value === props.operatorId
    );
    return (
        <React.Fragment>
            <Select
                name={props.name}
                closeMenuOnSelect={true}
                value={defaultValue ? defaultValue : null}
                options={options}
                onChange={data => {
                    props.onOperatorsItemChange(data);
                }}
                styles={{
                    control: (styles, {data, isSelected}) => ({
                        ...styles,
                        color: '#3e5569',
                        backgroundColor: 'white',
                        borderColor: '#e9ecef'
                    }),
                    singleValue: (styles, {data}) => ({
                        ...styles,
                        color: '#3e5569'
                    }),
                }}
            />
        </React.Fragment>
    )
};

OperatorSelector.propTypes = {
    name: PropTypes.string,
    operators: PropTypes.object,
    operatorId: PropTypes.number,
    onOperatorsItemChange: PropTypes.func
};

export default OperatorSelector;


// WEBPACK FOOTER //
// ./src/components/Application/OperatorSelector.js